module.exports = __webpack_public_path__ + "img/901.4a3141e7.png";